import React from "react";
import styles from "./ShippingPolicy.module.css";

const ShippingPolicy = () => {
  return (
    <div className={styles.policyContainer}>
      <h1 className={styles.title}>Shipping & Delivery Policy</h1>
      <p className={styles.subtitle}>
        As Sageion.com provides digital SaaS products, there is no physical
        shipping involved.
      </p>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>1. Digital Delivery</h2>
        <p className={styles.text}>
          All our products and services are delivered digitally through your
          registered email address or account dashboard immediately after
          successful payment.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>2. Delivery Time</h2>
        <p className={styles.text}>
          Access to services is usually provisioned instantly. In rare cases,
          it may take up to 24 hours due to system or network delays.
        </p>
      </section>

      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>3. Support</h2>
        <p className={styles.text}>
          If you face any issues accessing your purchase, please contact us at{" "}
          <strong>support@sageion.com</strong>.
        </p>
      </section>
    </div>
  );
};

export default ShippingPolicy;
